/**
 * Define an object with a set of known properties, each of which will be a
 * getter returning a string. This is mostly used for internationalization.
 */
export function defineGetters<P extends string>(
  input: Record<P, () => string>,
) {
  const result: Partial<Record<P, string>> = {};
  for (const [key, fn] of Object.entries(input)) {
    const get = fn as () => string;
    Object.defineProperty(result, key, { enumerable: true, get });
  }
  return result as Record<P, string>;
}
